import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img} from 'ui';
import {Link} from 'react-router-dom';

export const RecipeTeaser = styled(Link)({
  display: 'flex',
  flexDirection: 'column',
  width: 185,
  marginBottom: 32,
  textDecoration: 'none',
});

export const RecipeTitle = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  height: 86,
  backgroundColor: colors.white,
  paddingLeft: 10,
  paddingRight: 10,
});

export const Image = styled(Img)({
  width: 185,
  height: 209,
  backgroundSize: 'cover',
});
